import axios from '../axios';

export const all = () => {
  return axios.get('/customer-questions');
};

export const show = (id) => {
  return axios.get(`/customer-questions/${id}`);
};